import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.no-permission.title',
		defaultMessage: 'Limited issue permissions',
		description:
			'Heading for a section that tells the user they do not have permission to view the Jira issues contained in a deployment.',
	},
	titleIssueTermRefresh: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.no-permission.title-issue-term-refresh',
		defaultMessage: 'Limited work item permissions',
		description:
			'Heading for a section that tells the user they do not have permission to view the Jira issues contained in a deployment.',
	},
	description: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.no-permission.description',
		defaultMessage:
			"You don't have permission to view the issues included in this deployment. Contact project admin for details.",
		description:
			'Explanatory text telling the user they do not have permission to view the Jira issues contained in a deployment.',
	},
	descriptionIssueTermRefresh: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.no-permission.description-issue-term-refresh',
		defaultMessage:
			"You don't have permission to view the work items included in this deployment. Contact project admin for details.",
		description:
			'Explanatory text telling the user they do not have permission to view the Jira issues contained in a deployment.',
	},
	learnMore: {
		id: 'software-deployment-frequency-report-deployment-details-dialog.body.no-permission.learn-more',
		defaultMessage: 'Learn more.',
		description:
			'Text for a link that explains why the user does not have permission for the issues in the deployment.',
	},
});
